export default {
  data() {
    return {
      submitted: false,
    };
  },
  computed: {
    hasErrors() {
      const errors = Object.keys(this.errors).filter(field => this.getErrors(field).length > 0);
      if (errors.length > 0) {
        return false;
      }
      return null;
    },
  },
  watch: {
    model() {
      if (this.submitted) {
        this.checkForm();
      }
    },
  },
  methods: {
    callValidationFunctions(field, validation) {
      switch (validation) {
      case 'field':
        break;
      case 'equals':
        this.errors[field].equals = this.isEquals(
          field,
          this.errors[field].field
        );
        break;
      case 'isEmail':
        this.errors[field].isEmail = this.isEmail(field);
        break;
      case 'required':
      default:
        this.errors[field].required = this.isRequired(field);
        break;
      }
    },
    checkFields() {
      Object.keys(this.errors).forEach(field => {
        Object.keys(this.errors[field]).forEach(validation => {
          this.callValidationFunctions(field, validation);
        });
      });
    },
    checkForm() {
      this.submitted = true;
      this.checkFields();
      if (this.hasErrors == null) {
        this.submitted = false;
        return true;
      }
      return false;
    },
    getErrors(field) {
      return Object.keys(this.errors[field]).filter(error => this.errors[field][error] === true);
    },
    getInput(field) {
      if (this.model[field] === undefined) {
        return field;
      }
      return this.model[field];
    },
    hasErrorField(field = 'name') {
      if (this.submitted) {
        if (this.getErrors(field).length) {
          return 'invalid';
        }
        return 'valid';
      }
      return null;
    },
    isEquals(field, otherField) {
      const input = this.getInput(field);
      const otherInput = this.getInput(otherField);
      if (input !== otherInput) {
        return true;
      }
      return false;
    },
    isRequired(field) {
      const input = this.getInput(field);
      if (!input || input === '') {
        return true;
      }
      return false;
    },
    isEmail(field) {
      const input = this.getInput(field);
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return !emailRegex.test(input);
    },
    invalidFeedbackEmail(field) {
      const input = this.getInput(field);
      const isValid = this.errors.email.isEmail;
      return isValid && input
        ? 'E-mail inválido'
        : 'E-mail é obrigatório';
    },
  },
};
